import { render, staticRenderFns } from "./switchOrganization.vue?vue&type=template&id=201cebd2&lang=pug"
import script from "./switchOrganization.vue?vue&type=script&lang=js"
export * from "./switchOrganization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports